import React, { useContext } from 'react'
import { Grid, Typography } from '@mui/material'
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import { ImageSearchContext } from '../ImageSearchQueryContext';

const Navigation = () => {
    const { screen } = useContext(ImageSearchContext);
    return screen !== 1 && <Grid container sx={{ marginBottom: '24px' }}>
        <Typography sx={{ fontSize: '14px', color: '#4C4C4C', fontWeight: 500 }}>
            Lockbox Activity & Image Inquiry Criteria
        </Typography>
        <ChevronRightOutlinedIcon fontSize='small' color='#4C4C4C' />
        <Typography sx={{ fontSize: '14px', color: '#4C4C4C', fontWeight: 500 }}>
            Search
        </Typography>
        {screen > 2 && <>
            <ChevronRightOutlinedIcon fontSize='small' color='#4C4C4C' />
            <Typography sx={{ fontSize: '14px', color: '#4C4C4C', fontWeight: 500 }}>
                Daily Details
            </Typography>
        </>}
    </Grid>

}

export default Navigation